const state = () => {
    return {
        scouting_filters: {},
        scouting: {},
        scoutings: [],
    }
}

export default state;
